import { useCallback, useState } from 'react';

import { FORM_PROMPT_DEFAULT_MESSAGE } from '../components/ConfirmBeforeExitForm';

export const useActionBlocker = (action?: () => void) => {
  const [mustBlockAction, setMustBlockAction] = useState(false);

  const blockableAction = useCallback(() => {
    if (!mustBlockAction) {
      action?.();
    } else {
      const confirmed = window.confirm(FORM_PROMPT_DEFAULT_MESSAGE);

      if (confirmed) {
        action?.();
      }
    }
  }, [mustBlockAction, action]);

  return [blockableAction, setMustBlockAction] as const;
};
